(() => {
  const initializeGuideCta = (root = document) => {
    const mobileCtas = root.querySelectorAll('[data-tfbh-mobile-cta]');

    mobileCtas.forEach((mobileCta) => {
      if (mobileCta.dataset.tfbhInitialized === 'true') return;
      mobileCta.inert = true;

      const hero = document.querySelector('[data-tfbh-hero]');
      if (!hero || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting;
        mobileCta.classList.toggle('is-visible', visible);
        mobileCta.setAttribute('aria-hidden', String(!visible));
        mobileCta.inert = !visible;
      }, { threshold: 0.05 });

      observer.observe(hero);
      mobileCta.dataset.tfbhInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGuideCta(), { once: true });
  } else {
    initializeGuideCta();
  }

  document.addEventListener('shopify:section:load', (event) => initializeGuideCta(event.target));
})();
